import React, { useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import getDecryptedToken from "../../../../../../../../api/getDecryptedToken";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { insertBreaks } from "../../../../../../../../utils/functions/resize";

const user: string | undefined = getDecryptedToken("userName");

function AllSubTreatmentTr({
  items,
  paid,
  refresh,
  _id,
  allTeatment,
  setallTeatment,
  item,
}: any) {
  const dateNow = new Date();
  const { ID } = useParams();
  const [status, setstatus] = useState(items?.status);
  const handleDelete = (e: any) => {
    setallTeatment((prevTreatments: any) =>
      prevTreatments.map((item: any) => {
        if (item._id === _id) {
          return {
            ...item,
            subTreatment: item.subTreatment.filter(
              (subItem: any) => subItem._id !== e
            ),
          };
        }
        return item;
      })
    );
    baseUrl
      .patch("/client/treatments/subTreatment/delete-subtreetment", {
        maintreatmentid: ID,
        treatmentid: _id,
        subtreatmentid: e,
      })
      .then((response) => {
        refresh();
        console.log(response?.data);
      })
      .catch((error) => {
        console.error("Error removing treatment:", error);
      });
  };
  const handleSelectClick = () => {
    if (items?._id === undefined) {
      refresh();
    }
  };
  const handleSelect = (e: any) => {
    if (items?._id) {
      setstatus(e.target.value);
      baseUrl
        .patch(
          "/client/treatments/subTreatment/add-subtreetmentStatus",
          { status: e.target.value },
          {
            headers: {
              maintreatmentid: ID,
              treatmentid: item._id,
              subtreatmentid: items._id,
            },
          }
        )
        .then((response) => {
          refresh();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <tr className="hover:bg-amber-50/50 transition-colors">
      <td className="px-3 py-2 text-xs text-amber-800">
        {new Date(items?.createdAt)
          ? new Date(items?.createdAt).toISOString()?.split("T")[0]
          : new Date(dateNow).toISOString().split("T")[0]}
      </td>
      <td className="px-3 py-2 text-xs font-medium text-amber-900">
        {items?.treatment}
        {items?.type ? " - " + items?.type : ""}
        {items?.subtype ? " - " + items?.subtype : ""}
      </td>
      <td className="px-3 py-2 text-xs text-amber-800">{items?.toothNo}</td>
      <td className="px-3 py-2 text-xs text-amber-800">{items?.surface}</td>
      <td className="px-3 py-2 text-xs text-amber-800">{items?.quantity}</td>
      <td className="px-3 py-2 text-xs font-medium text-amber-900">Rs {items?.price}</td>
      <td className="px-3 py-2 text-xs text-amber-800" onClick={handleSelectClick}>
        {items?.selected_option === "treatment_paid" ? (
          <select
            value={status}
            onChange={handleSelect}
            className={`px-2 py-1 rounded text-xs font-medium border-0 cursor-pointer ${
              status === "Complete"
                ? "bg-emerald-100 text-emerald-700"
                : status === "ongoing"
                ? "bg-amber-200 text-amber-800"
                : "bg-slate-100 text-slate-600"
            }`}
          >
            {!items?.paid && <option value="planned">Planned</option>}
            <option value="ongoing">Ongoing</option>
            <option value="Complete">Complete</option>
          </select>
        ) : (
          <span className="px-2 py-1 rounded text-xs bg-slate-100 text-slate-600">{status}</span>
        )}
      </td>
      <td className="px-3 py-2 text-xs text-amber-800">
        {items?.didBy
          ? items?.didBy?.firstName + " " + (items?.didBy?.lastName ?? "")
          : user}
      </td>
      <td className="px-3 py-2 text-xs text-amber-700 max-w-[120px] truncate">{insertBreaks(items?.note)}</td>
      <td className="px-3 py-2">
        {!items?.paid && (
          <button
            onClick={() => handleDelete(items?._id)}
            className="w-7 h-7 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 flex items-center justify-center transition-colors"
          >
            <DeleteOutlineIcon sx={{ fontSize: 16 }} />
          </button>
        )}
      </td>
    </tr>
  );
}

export default AllSubTreatmentTr;
